import React, { useEffect, useCallback } from "react";
import DesktopHeader from "./desktop";
import MobileHeader from "./mobile";
import AnnouncementBanner from "./announcement-banner";


const Header = ({ data }) => {
    const updateContainerHeight = useCallback(() => {
        const element = document.querySelector('.ub-emb-bar-frame');
        if (element) {
            setTimeout(() => {
                const height = element.offsetHeight;
                document.documentElement.style.setProperty('--ub-em-container-height', height + 'px');
            }, 1000);
        } else {
            document.documentElement.style.setProperty('--ub-em-container-height', '0px');
        }
    }, []);

    useEffect(() => {
        updateContainerHeight();

        const observer = new MutationObserver(updateContainerHeight);
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        return () => observer.disconnect();
    }, [updateContainerHeight]);

    return (
        <>
            {data?.announcementBanner?.show && <AnnouncementBanner data={data} />}
            <DesktopHeader data={data} />
            <MobileHeader data={data} />
        </>
    )
}

export default Header;
